<template>
    <div class="container-fluid">

        <div id="accordion">
            <div class="card">
                <div class="card-header" v-on:click="show = !show">
                    <div class="row mb-3 px-3">
                        <div>
                            <button class="all-btn add-btn">{{$t("main.search")}} .... </button>
                        </div>
                        <div v-if="hasPermission('CASH_TRANSFER')">
                            <button type="button" class="all-btn" @click="addAppraiserUrl()">
                                {{$t("finance.deposit.cashTransfer")}}
                            </button>
                        </div>
                    </div>
                </div>

                <div v-if="show" id="collapseOne" class="collapse show" data-parent="#accordion">
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="form-check checkbox-inline">
                                <label class="form-check-label"
                                       style="padding-left:22px !important">
                                    <input class="form-check-input" type="checkbox"
                                           v-model="roleAppraiser"
                                           @change="onDepositChange('ROLE_APPRAISER',$event)"
                                    >
                                    <span class="form-check-sign"></span>
                                    {{$t("realEstate.field.evaluator")}}
                                </label>
                            </div>
                            <div class="form-check checkbox-inline">
                                <label class="form-check-label">
                                    <input class="form-check-input" type="checkbox"
                                           v-model="roleAppraiserHelper"
                                           @change="onDepositChange('ROLE_APPRAISER_HELPER',$event)"
                                    >
                                    <span class="form-check-sign"></span>
                                    {{$t("report.field.agents")}}
                                </label>
                            </div>
                            <div class="form-check checkbox-inline">
                                <label class="form-check-label">
                                    <input class="form-check-input" type="checkbox"
                                           v-model="roleRegionalLeader"
                                           @change="onDepositChange('ROLE_REGIONAL_LEADER',$event)"
                                    >
                                    <span class="form-check-sign"></span>
                                    Худудий рахбарлар
                                </label>
                            </div>
                            <div class="form-check checkbox-inline">
                                <label class="form-check-label">
                                    <input class="form-check-input" type="checkbox"
                                           v-model="roleAdmin"
                                           @change="onDepositChange('ROLE_ADMIN',$event)"
                                    >
                                    <span class="form-check-sign"></span>
                                    Админлар
                                </label>
                            </div>

                        </div>
                        <div class="row">

                            <div class="col-xl-3 col-lg-4 col-md-6 mb-2" v-if="roleAppraiserHelper">
                                <label>{{$t("report.field.agents")}}</label>
                                <v-select v-model="filter.user" label="name"
                                          :options="users"
                                          :filterable="false"
                                          @search="onUsersSearch"
                                          @search:focus="onUsersFocus">
                                    <template slot="option" slot-scope="option" v-if="option">
                                        <div v-html="option.name"></div>
                                    </template>
                                    <template slot="selected-option"
                                              v-if="filter && filter.user && filter.user.name">
                                        <div v-html="filter.user.name"
                                             @click="$eventBus.$emit('search:focus')"></div>
                                    </template>
                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                </v-select>
                            </div>

                            <div class="col-xl-3 col-lg-4 col-md-6 mb-2" v-if="roleRegionalLeader">
                                <label>Худудий рахбарлар</label>
                                <v-select v-model="filter.user" label="name"
                                          :options="leaders"
                                          :filterable="false"
                                          @search="onRegionalLeaderSearch"
                                          @search:focus="onRegionalLeaderFocus">
                                    <template slot="option" slot-scope="option" v-if="option">
                                        <div v-html="option.name"></div>
                                    </template>
                                    <template slot="selected-option"
                                              v-if="filter && filter.user && filter.user.name">
                                        <div v-html="filter.user.name"
                                             @click="$eventBus.$emit('search:focus')"></div>
                                    </template>
                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                </v-select>
                            </div>

                            <div class="col-xl-3 col-lg-4 col-md-6 mb-2" v-if="roleAppraiser">
                                <label>{{$t("realEstate.field.evaluator")}}</label>
                                <v-select v-model="employee" label="name"
                                          :options="employees"
                                          :filterable="false"
                                          @input="onGroupChange"
                                          @search:focus="onEmployeFocus">
                                    <template slot="option" slot-scope="option" v-if="option && option.name">
                                        <div v-html="option.name"></div>
                                    </template>
                                    <template slot="selected-option"
                                              v-if="filter && filter.employee && filter.employee.name">
                                        <div v-html="filter.employee.name"></div>
                                    </template>
                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                </v-select>
                            </div>

                            <div class="col-xl-3 col-lg-4 col-md-6 mb-2" v-if="roleAdmin">
                                <label>{{$t("realEstate.field.admin")}}</label>
                                <v-select v-model="filter.user" label="name"
                                          :options="admins"
                                          :filterable="false"
                                          @search:focus="getAdminFocus">
                                    <template slot="option" slot-scope="option" v-if="option && option.name">
                                        <div v-html="option.name"></div>
                                    </template>
                                    <template slot="selected-option"
                                              v-if="filter && filter.employee && filter.employee.name">
                                        <div v-html="filter.employee.name"></div>
                                    </template>
                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                </v-select>
                            </div>

                            <div class="col-xl-2 col-md-3 col-sm-6 mb-2">
                                <label>{{$t("report.date.startDate")}}</label>
                                <datepicker
                                        class="form-control"
                                        format="dd/MM/yyyy"
                                        v-model="filter.startDate"
                                        :clear-button="true"
                                        @input="changeStartDate"
                                ></datepicker>
                            </div>
                            <div class="col-xl-2 col-md-3 col-sm-6 mb-2">
                                <label>{{$t("report.date.endDate")}}</label>
                                <datepicker
                                        class="form-control"
                                        format="dd/MM/yyyy"
                                        v-model="filter.endDate"
                                        :clear-button="true"
                                ></datepicker>
                            </div>
                            <div class="col-sm-1 align-self-end">
                                <label style="align-self: center">{{$t("main.search")}}</label>
                                <button class="all-btn m-0 mb-2 form-control" @click="searchByFilter"
                                        style="color: #fff;background-color: #00bcd4;border-color: #00bcd4;
                                        box-shadow: 0 2px 2px 0 rgba(0, 188, 212, .14),
                                        0 3px 1px -2px rgba(0, 188, 212, .2),
                                        0 1px 5px 0 rgba(0, 188, 212, .12)">
                                    <i class="fa fa-filter"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body scroll-card-body">
                        <table class="customers">
                            <thead class="table-head">
                            <tr>
                                <th>№</th>
                                <th>{{$t("finance.balance.fullName")}}</th>
                                <th>{{$t("finance.balance.user")}} ({{$t("finance.balance.fullName")}})</th>
                                <th>{{$t("finance.balance.statusBalance")}}</th>
                                <th>{{$t("finance.balance.date")}}</th>
                                <th>{{$t("finance.balance.cashAmount")}}</th>
                            </tr>

                            </thead>
                            <tbody>
                            <template v-if="results">
                                <tr v-for=" (result) in results.data" :key="result.id">
                                    <td>{{result.id}}</td>
                                    <td>
                                        <span class="">
                                            {{result.createdBy!=null?result.createdBy.name:''}}
                                        </span><br/>
                                        <span class="font-weight-bold small">
                                            <b>{{result.createdUserRoleName}}</b>
                                        </span> <br/>
                                        <span class="font-weight-bold font-italic" style="font-size: 10px; color: red">
                                            {{result.createdBy.region!=null && result.createdBy.region.provinceDto!=null?result.createdBy.region.provinceDto.name:''}}
                                        </span><br/>
                                        <span class="font-weight-bold font-italic"
                                              style="font-size: 10px; color: #0b75c9">
                                            {{result.createdBy.region!=null?result.createdBy.region.name:''}}
                                        </span>
                                    </td>
                                    <td>
                                        <span class="">
                                            {{result.receiverUser!=null?result.receiverUser.name:''}}
                                        </span><br/>
                                        <span class="font-weight-bold small">
                                            <b>{{result.receiverUserRoleName!=null?result.receiverUserRoleName:''}}</b>
                                        </span> <br/>
                                        <span class="font-weight-bold font-italic" style="font-size: 10px; color: red">
                                            {{result.receiverUser!=null && result.receiverUser.region!=null && result.receiverUser.region.provinceDto!=null?result.receiverUser.region.provinceDto.name:''}}
                                        </span><br/>
                                        <span class="font-weight-bold font-italic"
                                              style="font-size: 10px; color: #0b75c9">
                                            {{result.receiverUser!=null &&  result.receiverUser.region!=null?result.receiverUser.region.name:''}}
                                        </span>
                                    </td>
                                    <td>{{result.objectName}}</td>
                                    <td>{{result.confirmedDate}}</td>
                                    <td>{{result.balance}}</td>
                                </tr>
                            </template>
                            </tbody>
                            <tfoot>
                            <!--<tr v-if="loadingTotal">-->
                            <!--<loading2 style="" v-if="loadingTotal"></loading2>-->
                            <!--</tr>-->
                            <!--<tr v-if="!loadingTotal">-->
                            <tr>
                                <td colspan="6" class="font-weight-bold"></td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div class="text-center">
                        <div class="loader mt-5 mb-5" v-if="loading"></div>
                        <span class="no-data mt-5 mb-5"
                              v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
                    </div>
                    <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                        <div class="col-12 pt-3 pb-3">
                            <b-pagination :total-rows="results.total" v-model="filter.page.page"
                                          :per-page="filter.page.size" @change="onPageChange">
                            </b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>


<script>
    import Datepicker from 'vuejs-datepicker';
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import initFilterModel from '@/shared/filter';
    import {formatDate, parseDate, format_date} from '@/shared/utils';
    // export const
    export default {
        name: "UsersBalance",
        components: {
            'b-pagination': bPagination,
            Datepicker
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: null,
                show: false,
                loadingTotal: true,
                roleAppraiser: false,
                roleAppraiserHelper: false,
                roleRegionalLeader: false,
                roleAdmin: false,
                employee: null,
                users: [],
                employees: [],
                leaders: [],
                admins: []
            }
        },
        methods: {
            searchByFilter() {
                this.filter.page.page = 1;
                if (this.filter.startDate < new Date("2021" ,"07", "26")) {
                    this.filter.startDate = new Date("2021" ,"07", "26");
                }
                this.initList();
            },
            initList() {
                const vm = this;
                this.filter.startDate = formatDate(this.filter.startDate);
                this.filter.endDate = formatDate(this.filter.endDate);
                this.filter.startDate = parseDate(this.filter.startDate);
                this.filter.endDate = parseDate(this.filter.endDate);
                this.loading = true;
                this.$http.post('/report/list/user/balance', this.filter).then(res => {
                    vm.results = res.data;
                    vm.loading = false;
                }, err => {
                    console.log(err);
                    vm.loading = false;
                });

            },
            changeStartDate() {
                if (this.filter.startDate < new Date("2021" ,"07", "26")) {
                    this.$swal({
                        title: this.$t('messages.common.warning'),
                        text: formatDate(new Date("2021" ,"07", "26")) + ' дан олдинги сана танлаш мумкин эмас',
                        type: 'warning'
                    });
                    this.initList();
                }

            },
            onDepositChange(value, $event) {
                const checked = $event.target.checked;

                if (checked && this.roleAppraiser) {
                    this.roleAppraiserHelper = false;
                    this.roleRegionalLeader = false;
                    this.roleAdmin = false;
                }
                if (checked && this.roleAppraiserHelper) {
                    this.roleAppraiser = false;
                    this.roleRegionalLeader = false;
                    this.roleAdmin = false;
                }
                
                if (checked && this.roleRegionalLeader) {
                    this.roleAppraiser = false;
                    this.roleAppraiserHelper = false;
                    this.roleAdmin = false;
                }
                if (checked && this.roleAdmin) {
                    this.roleAppraiser = false;
                    this.roleAppraiserHelper = false;
                    this.roleRegionalLeader = false;
                }
            },
            format_date(value) {
                if (value) {
                    return format_date(value)
                }
                return null;
            },

            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            addAppraiserUrl() {
                this.$http.get('/deposit/user-balance/')
                    .then(res => {
                        const totalBalance = res.data.data;
                        if (totalBalance > 0) {
                            this.$router.push('/finance/deposit/add/' + totalBalance + '/ROLE_APPRAISER');
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.error'),
                                text: "Пул миқдори " + totalBalance + " сўм етарли эмас ",
                                type: 'error'
                            });
                        }
                    }, err => {
                        console.log(err)
                    });
            },
            onUsersSearch(searchTxt) {
                this.users = [];
                this.filter.search = searchTxt;
                this.$http.post('user/agent', this.filter)
                    .then(res => {
                        this.users = res.data.data;
                        this.filter.search = '';
                    }, err => {
                        console.log(err);
                    });
            },
            onUsersFocus() {
                this.users = [];
                this.filter.search = '';
                this.$http.post('user/agent', this.filter)
                    .then(res => {
                        this.users = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onEmployeFocus() {
                this.employees = [];
                this.filter.search = '';
                this.$http.post('employes/search', this.filter)
                    .then(res => {
                        this.employees = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onGroupChange() {
                const vm = this;
                this.$http.get('/employee/' + this.employee.id)
                    .then(res => {
                        vm.depositsDto.user = res.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onRegionalLeaderSearch(search) {
                this.leaders = [];
                this.filter.search = search;
                this.$http.post('/user/regional-leader', this.filter)
                    .then(res => {
                        this.leaders = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onRegionalLeaderFocus() {
                this.leaders = [];
                this.filter.search = '';
                this.$http.post('/user/regional-leader', this.filter)
                    .then(res => {
                        this.leaders = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            getAdminFocus() {
                this.filter.search = 'ROLE_ADMIN';
                this.$http.post('/user/list-role', this.filter)
                    .then(res => {
                        this.admins = res.data.data;
                    }, err => {
                        console.log(err)
                    });
            },
        },
        created() {
            var d = new Date();
            var currMonth = d.getMonth();
            var currYear = d.getFullYear();
            this.filter.startDate = new Date(currYear, currMonth, 1);
            this.filter.endDate = new Date(currYear, currMonth, d.getDate());
            this.initList()
        }
    }
</script>

<style scoped>

    .scroll-card-body {
        overflow-x: scroll;
        overflow-y: visible;
    }

    td {
        border-top: 1px solid #dee2e6;
    }

    th, td {
        padding: .5rem;
        /*cursor: col-resize;*/
    }

</style>
